import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GestaoRoutingModule } from './gestao-routing.module';
import { DashboardGestaoComponent } from './pages/dashboard-gestao/dashboard-gestao.component';
import { FaturarComponent } from './pages/financeiro/faturar/faturar.component';
import { ListaComponent } from './pages/financeiro/lista/lista.component';
import { EmpresasComponent } from './pages/cadastros/empresas/empresas.component';
import { FaqComponent } from './pages/cadastros/faq/faq.component';
import { HelpComponent } from './pages/cadastros/help/help.component';
import {ComponentesModule} from "../../core/componentes/componentes.module";
import { ListaNotificacaoComponent } from './pages/cadastros/lista-notificacao/lista-notificacao.component';


@NgModule({
  declarations: [
    DashboardGestaoComponent,
    FaturarComponent,
    ListaComponent,
    EmpresasComponent,
    FaqComponent,
    HelpComponent,
    ListaNotificacaoComponent
  ],
  imports: [
    CommonModule,
    GestaoRoutingModule,
    ComponentesModule
  ]
})
export class GestaoModule { }
